<script>
import Drawer from './components/Drawer.svelte';
import Alerts from './components/Alerts.svelte';

import config from './../config.js'
import { user } from './stores.js'
import { onMount } from 'svelte'

let data = {"blackflies": "none","horseflies": "none","mosquitoes": "none"}

onMount(async () => {
    let headers = new Headers()
    const { insect } = config

    let current_user
    const unsubscribe = user.subscribe((value) => {
        current_user = value
    })

    if (current_user.token) {
        headers.set('authorization', 'Bearer ' + current_user.token)
    }
    headers.set('Content-Type', 'application/json')

    const res = await fetch(insect['url'], {
        method: 'get',
        headers: headers
    })
    data = await res.json()
})

  

</script>

<style>
.row {
  display: flex;
  justify-content: space-evenly;
}
@media only screen and (max-width: 600px) {
  .row {
    display: block;
  }
}
h2, h3 {
  text-align: center;
}
h3 {
  font-style: italic;
  margin-bottom: 3em;
}
.bug {
  height: 100px;
  width: 100px;
  display: block;
  margin: auto;
}
.high svg path {
  fill: rgb(238, 66, 102);
}
.medium svg path {
  fill: rgb(253, 158, 34);
}
.low svg path {
  fill: rgb(255, 224, 121);
}
.none svg path {
  fill: grey;
}

</style>

<Drawer />
<Alerts />

<div class="container">
    <h1>Bugs</h1>
    <div class="row">
        <div class="col">
            <h2>Mosquitoes</h2>
            <h3>Culicidae</h3>
            
            <span class="bug {data['mosquitoes']}" title="Mosquitoes">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 512 512"><path d="M453.5 324c-15.5-26.8-42-60-68.1-85.5h39.1c9.4 0 17.1-7.6 17.1-17.1s-7.6-17.1-17.1-17.1h-81.8c-2.7-1.6-5.3-2.9-7.9-4.1l46-18.3c6.5-2.6 10.8-8.9 10.8-15.9V45c0-9.4-7.6-17.1-17.1-17.1s-17.1 7.6-17.1 17.1v109.5l-52 20.7c9.1-11 14.5-25.2 14.5-40.5 0-29.4-19.9-54.2-46.9-61.6V17.1C273.1 7.6 265.4 0 256 0c-9.4 0-17.1 7.6-17.1 17.1v55.9c-27 7.5-46.9 32.3-46.9 61.6 0 15.4 5.4 29.5 14.5 40.5l-52-20.7V45c0-9.4-7.6-17.1-17.1-17.1s-17.1 7.6-17.1 17.1v121.1c0 7 4.3 13.3 10.8 15.9l46.1 18.4c-2.6 1.2-5.2 2.6-7.8 4.1H87.5c-9.4 0-17.1 7.6-17.1 17.1s7.6 17.1 17.1 17.1h39.1c-25.9 25.2-52.7 58.9-68.1 85.5 -27 46.8-32.5 101 12.6 127 29 16.8 60.4 9.5 86-13.6v57.5c0 9.4 7.6 17.1 17.1 17.1s17.1-7.6 17.1-17.1V391.6c0.5-1 1-1.9 1.6-2.9 10.9 24.1 35.1 41 63.3 41s52.4-16.9 63.3-41c0.5 1 1 1.9 1.6 2.9v103.3c0 9.4 7.6 17.1 17.1 17.1s17.1-7.6 17.1-17.1v-57.5c25.6 23.2 57 30.3 86 13.6h0C485.9 425.1 480.7 371.1 453.5 324zM142 404.2c-24.4 28-44.2 22.9-53.8 17.3 -27.4-15.8-15.9-53.1-0.1-80.4 27.8-48.1 89.2-110.5 111.6-112.6 0 0 0 0.1 0.1 0.1C209.4 252.3 179 361.5 142 404.2zM423.8 421.5c-9.6 5.6-29.4 10.7-53.8-17.3 -37.2-42.8-68-154-57.6-175.7 22.5 2.2 83.9 64.8 111.6 112.6C439.8 368.5 451.2 405.7 423.8 421.5z"/></svg>
            </span>
        </div>
        <div class="col">
            <h2>Blackflies</h2>
            <h3>Simuliidae</h3>
            
            <span class="bug {data['blackflies']}" title="Black flies">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 186.2 186.2"><path d="M147.4 55.7c-10.1-9.1-21.8-15.8-34.6-19.8 0.6-0.9 1-2 1.3-3.1 1.7-6.2-2-12.6-8.2-14.3 -2-0.5-4-0.5-5.8-0.1V7c0-3.9-3.1-7-7-7s-7 3.1-7 7v11.5c-6.1-1.5-12.4 2.2-14 8.3 -0.9 3.2-0.3 6.5 1.3 9.1 -12.8 4-24.5 10.7-34.6 19.8C10.4 81.3 0.4 121.1 13.2 157.1c1 2.8 3.7 4.7 6.6 4.7 0.4 0 0.8 0 1.2-0.1 12.4-2.2 24.1-6.8 34.7-13.5 3.8 8.1 8.7 16.7 14.6 25.8 5 7.7 13.6 12.4 22.8 12.4 0 0 0 0 0 0 9.2 0 17.8-4.6 22.8-12.4 5.9-9.1 10.8-17.7 14.6-25.8 10.5 6.7 22.3 11.3 34.7 13.5 0.4 0.1 0.8 0.1 1.2 0.1 2.9 0 5.6-1.8 6.6-4.7C185.8 121.1 175.8 81.3 147.4 55.7zM48.2 66.1c10.8-9.7 23.8-16.3 37.9-19.1l0 19.6c0 0.1 0 0.1 0 0.2 0.2 23.2-9.6 45.5-27 61.2 -9.9 8.9-21.8 15.3-34.5 18.6C16.6 117.5 25.6 86.5 48.2 66.1zM104.2 166.2c-2.5 3.8-6.5 6-11.1 6 -4.5 0-8.6-2.2-11.1-6 -6.2-9.5-11.2-18.5-14.9-26.7 0.4-0.4 0.9-0.8 1.3-1.1 10.9-9.8 19.3-21.9 24.6-35.2 5.4 13.3 13.7 25.3 24.6 35.2 0.4 0.4 0.9 0.8 1.3 1.1C115.4 147.7 110.4 156.7 104.2 166.2zM161.7 146.6c-12.8-3.3-24.6-9.6-34.5-18.6 -17.4-15.7-27.2-38-27-61.3V47.1c14.1 2.8 27.2 9.3 37.9 19.1C160.7 86.5 169.6 117.5 161.7 146.6z"/></svg>
            </span>
        </div>
        <div class="col">
            <h2>Horseflies</h2>
            <h3>Tabanidae</h3>

            <span class="bug {data['horseflies']}" title="Horse flies">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 205 205"><path d="m199 60.4c-2.9-3-7.6-3-10.6-0.2l-29.8 28.9c-7.3-9-14.9-17.7-22.1-25.4l14.4-6.4c1.9-0.8 3.3-2.4 4-4.4l15.1-43c1.4-3.9-0.7-8.2-4.6-9.6-3.9-1.4-8.2 0.7-9.6 4.6l-14 39.9-1.5 0.6c0-0.6 0.1-1.1 0.1-1.7 0-16.9-16.5-36.5-37.9-36.5-21.3 0-37.9 19.6-37.9 36.5 0 0.6 0 1.2 0.1 1.7l-1.5-0.6-14-39.9c-1.4-3.9-5.7-6-9.6-4.6-3.9 1.4-6 5.7-4.6 9.6l15.1 43c0.7 1.9 2.1 3.5 4 4.4l14.4 6.4c-7.2 7.7-14.8 16.3-22.1 25.4l-29.8-28.9c-3-2.9-7.7-2.8-10.6 0.2-2.9 3-2.8 7.7 0.2 10.6l31 30.1c-19.3 26.3-32.6 53.3-20.4 65.5 3.3 3.3 7.6 4.7 12.6 4.7 6.1 0 13.2-2.1 20.7-5.5l10.2 33.9c1 3.3 4 5.3 7.2 5.3 0.7 0 1.4-0.1 2.2-0.3 4-1.2 6.2-5.4 5-9.3l-11-36.8c4.5-2.7 9-5.6 13.3-8.6 4.7 9.2 14.4 15.6 25.4 15.6s20.7-6.3 25.4-15.6c4.4 3 8.8 6 13.3 8.6l-11 36.8c-1.2 4 1.1 8.1 5 9.3 0.7 0.2 1.4 0.3 2.2 0.3 3.2 0 6.2-2.1 7.2-5.3l10.2-33.9c7.5 3.4 14.6 5.5 20.7 5.5 5 0 9.3-1.4 12.6-4.7 12.2-12.2-1.1-39.2-20.4-65.5l31-30.1c3-2.9 3-7.6 0.2-10.6zm-96.4-38c12.3 0 22.9 11.8 22.9 21.5 0 11.7-19.1 12.3-22.9 12.3-3.8 0-22.9-0.6-22.9-12.3 0-9.7 10.6-21.5 22.9-21.5zm-75 133.6c-0.8-1.1-1.4-9.2 10.8-29.5 4.1-6.8 9.1-14 14.8-21.5 0.1-0.1 0.1-0.2 0.2-0.3 6.1-8 13.1-16.4 20.7-24.7v53.7c-29.3 21.5-44.3 23.8-46.4 22.2zm75-5.4c-7.5 0-13.6-6.1-13.6-13.6v-67.2c4.1 0.9 8.7 1.4 13.6 1.4 4.9 0 9.5-0.5 13.6-1.4v67.2c0 7.5-6.1 13.6-13.6 13.6zm75 5.4c-2.2 1.7-17.1-0.7-46.5-22.2v-53.7c7.6 8.4 14.6 16.7 20.7 24.7 0.1 0.1 0.1 0.2 0.2 0.2 5.7 7.5 10.7 14.7 14.8 21.5 12.2 20.2 11.6 28.4 10.8 29.4z"/></svg>
            </span>
        </div>
    </div>
</div>